import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { TablePagination as MuiTablePagination } from '@material-ui/core';

import type { ITableConsumerState } from './ITableConsumerState';
import { TableContext } from './TableContext';

interface TablePaginationProps {
    colSpan?: number;
}

export const TablePagination = <DataType, FilterType>({
    colSpan,
}: TablePaginationProps) => {
    const { t } = useTranslation();
    const context: ITableConsumerState<DataType, FilterType> | undefined =
        useContext(TableContext);

    if (!context?.data) {
        return null;
    }

    return (
        <MuiTablePagination
            component="td"
            colSpan={colSpan}
            rowsPerPageOptions={context.rowsPerPageOptions}
            count={context.data.length}
            rowsPerPage={context.rowsPerPage}
            page={context.page}
            labelDisplayedRows={({ from, to, count }) =>
                `${from}-${to} ${t('general.of')} ${count}`
            }
            labelRowsPerPage={t('tables.labelRowsPerPage')}
            onPageChange={context.handleChangePage}
            onRowsPerPageChange={context.handleChangeRowsPerPage}
            data-testid="TablePagination"
        />
    );
};
